import { Flex, FlexProps, Text } from '@chakra-ui/react';
import Case from 'case';
import { rem } from 'polished';
import { Fragment } from 'react';

type Props = FlexProps & {
  traits?: { key: string; value: string }[];
};

export const CollectionOfferTraits = ({ traits = [], ...flexProps }: Props) => {
  return (
    <Flex
      noOfLines={1}
      maxWidth={rem(200)}
      fontSize="sm"
      color="gray.5"
      wordBreak="break-all"
      {...flexProps}
    >
      {traits.map((trait, index, traits) => (
        <Fragment key={`${trait.key}-${trait.value}-${index}`}>
          <Text ml={!!index ? 'space.4' : undefined} as="strong">
            {trait.key && Case.capital(trait.key)}
          </Text>
          {`: ${trait.value}`}
          {index < traits.length - 1 ? ',' : ''}
        </Fragment>
      ))}
    </Flex>
  );
};
